module.exports = __webpack_public_path__ + "img/zu6828.d418ae14.svg";